import Spacer from 'features/shared/Spacer';
import SwitchTabs, { BlueLinksTab, BluePillsTab, SwitchTabsType } from 'features/shared/SwitchTabs';
import ReportDownloadBar from 'features/shared/DownloadBar/ReportDownloadBar';
import React, { useState } from 'react';
import {
  Subject,
  SubjectOption,
  subjectOptions,
  TestRound,
  TestRoundOption,
  testRoundsOptions,
} from 'features/monitoring/models';
import FileSaver from 'file-saver';
import { useClickStreamContext } from 'features/shared/ClickStream';

interface Props {
  subject: SubjectOption;
  setSubject: (value: SubjectOption) => void;
  testRound: TestRoundOption;
  setTestRound: (value: TestRoundOption) => void;
  reportText: React.ReactNode;
  getReport: () => Promise<string | Blob>;
  fileName: string;
  loggerPrefix: string;
  loggerPrefixTranslate: string;
}

export function TablePlateControls({
  subject,
  testRound,
  setSubject,
  setTestRound,
  reportText,
  getReport,
  fileName,
  loggerPrefix,
  loggerPrefixTranslate,
}: Props) {
  const { logPageEvent } = useClickStreamContext();

  const [isFetching, setIsFetching] = useState(false);

  const downloadReport = async () => {
    logPageEvent({
      eventType: 'monitoring_' + loggerPrefix + '_click_dowload_report',
      eventInfo: 'Срезы знаний|' + loggerPrefixTranslate + ': Нажал скачать отчет',
    });
    if (isFetching) {
      return;
    }
    setIsFetching(true);
    try {
      const result = await getReport();
      const blob = new Blob([result], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, fileName);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      <SwitchTabs
        tabRenderer={BluePillsTab}
        values={subjectOptions}
        value={subject}
        handleChange={(value) => {
          setSubject(value);
          logPageEvent({
            eventType: 'monitoring_' + loggerPrefix + '_tab_' + value.id,
            eventInfo: 'Срезы знаний|' + loggerPrefixTranslate + ':  Перешел на вкладку ' + value.label,
          });
        }}
        type={SwitchTabsType.pills}
      />
      <Spacer size={24} />
      <ReportDownloadBar onClick={downloadReport} title={isFetching ? 'Загружается' : 'Подробный отчет'}>
        {reportText}
      </ReportDownloadBar>
      <Spacer size={32} />
      <SwitchTabs
        values={testRoundsOptions}
        value={testRound}
        handleChange={(value) => {
          setTestRound(value);
          logPageEvent({
            eventType: 'monitoring_' + loggerPrefix + '_select_test_tab_' + value.id,
            eventInfo: 'Срезы знаний|' + loggerPrefixTranslate + ':  Выбрал вкладку с тестом ' + value.label,
          });
        }}
        tabRenderer={BlueLinksTab}
      />
    </>
  );
}
